import {
  Action, Dispatch, Middleware,
} from 'redux';
import service from '@mfe/service';
import { SET_EDIT_ACTIVE_GROUP_IND, CANCEL_EDIT_MODE } from '../consents';
import type { RootState } from '../index';

const scroller: Middleware<unknown, RootState> = () => (next) => (action) => {
  const ret = next(action) as Dispatch;
  const { type } = action as Action<string>;

  if (type === SET_EDIT_ACTIVE_GROUP_IND || type === CANCEL_EDIT_MODE) {
    service.scrollToTop();
  }
  return ret;
};

export default scroller;
